/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnnounceInMissionChatRequest,
  ChatMessageDto,
  GetApiV1MissionsMissionIdChatParams,
  ProblemDetails,
  SendChatMessageRequest,
  ValidationProblemDetails
} from '.././model';

import { request } from '../../http-client';




export const getApiV1MissionsMissionIdChat = (
    missionId: string,
    params?: GetApiV1MissionsMissionIdChatParams,
 signal?: AbortSignal
) => {
      
      
      return request<ChatMessageDto[]>(
      {url: `/api/v1/missions/${missionId}/chat`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdChatQueryKey = (missionId?: string,
    params?: GetApiV1MissionsMissionIdChatParams,) => {
    return [
    `/api/v1/missions/${missionId}/chat`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdChatQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError = ProblemDetails>(missionId: string,
    params?: GetApiV1MissionsMissionIdChatParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdChatQueryKey(missionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>> = ({ signal }) => getApiV1MissionsMissionIdChat(missionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdChatQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>>
export type GetApiV1MissionsMissionIdChatQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdChat<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError = ProblemDetails>(
 missionId: string,
    params: undefined |  GetApiV1MissionsMissionIdChatParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdChat<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError = ProblemDetails>(
 missionId: string,
    params?: GetApiV1MissionsMissionIdChatParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdChat<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError = ProblemDetails>(
 missionId: string,
    params?: GetApiV1MissionsMissionIdChatParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdChat<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError = ProblemDetails>(
 missionId: string,
    params?: GetApiV1MissionsMissionIdChatParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdChat>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdChatQueryOptions(missionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1MissionsMissionIdChat = (
    missionId: string,
    sendChatMessageRequest: SendChatMessageRequest,
 signal?: AbortSignal
) => {
      
      
      return request<ChatMessageDto>(
      {url: `/api/v1/missions/${missionId}/chat`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendChatMessageRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdChatMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChat>>, TError,{missionId: string;data: SendChatMessageRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChat>>, TError,{missionId: string;data: SendChatMessageRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdChat'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChat>>, {missionId: string;data: SendChatMessageRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdChat(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdChatMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChat>>>
    export type PostApiV1MissionsMissionIdChatMutationBody = SendChatMessageRequest
    export type PostApiV1MissionsMissionIdChatMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsMissionIdChat = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChat>>, TError,{missionId: string;data: SendChatMessageRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdChat>>,
        TError,
        {missionId: string;data: SendChatMessageRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdChatAnnounce = (
    missionId: string,
    announceInMissionChatRequest: AnnounceInMissionChatRequest,
 signal?: AbortSignal
) => {
      
      
      return request<ChatMessageDto>(
      {url: `/api/v1/missions/${missionId}/chat/announce`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: announceInMissionChatRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdChatAnnounceMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChatAnnounce>>, TError,{missionId: string;data: AnnounceInMissionChatRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChatAnnounce>>, TError,{missionId: string;data: AnnounceInMissionChatRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdChatAnnounce'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChatAnnounce>>, {missionId: string;data: AnnounceInMissionChatRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdChatAnnounce(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdChatAnnounceMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChatAnnounce>>>
    export type PostApiV1MissionsMissionIdChatAnnounceMutationBody = AnnounceInMissionChatRequest
    export type PostApiV1MissionsMissionIdChatAnnounceMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsMissionIdChatAnnounce = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdChatAnnounce>>, TError,{missionId: string;data: AnnounceInMissionChatRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdChatAnnounce>>,
        TError,
        {missionId: string;data: AnnounceInMissionChatRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdChatAnnounceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    